import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import { FiInfo } from 'react-icons/fi';

const Pricing = () => {
  return (
    <div className="pt-24 pb-20 bg-primary min-h-screen">
      <div className="container mx-auto px-6">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-16"
        >
          <h1 className="text-4xl md:text-6xl font-display mb-6">Investment</h1>
          <div className="w-20 h-1 bg-secondary mx-auto mb-6"></div>
          <p className="text-muted max-w-2xl mx-auto">
            Quality tattoos are an investment in yourself. Our pricing reflects the experience, hygiene standards, and artistic caliber of our studio.
          </p>
        </motion.div>

        <div className="max-w-4xl mx-auto bg-background border border-gray-800 p-8 md:p-12">
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            <div>
              <h3 className="text-2xl font-display text-light mb-8 border-b border-gray-800 pb-4">General Pricing Guide</h3>
              
              <ul className="space-y-6">
                <li className="flex justify-between items-end border-b border-gray-800/50 pb-2">
                  <div>
                    <span className="block text-light font-medium">Minimum Tattoo</span>
                    <span className="text-xs text-muted">Shop minimum for setup</span>
                  </div>
                  <span className="text-secondary font-display text-xl">CA$120</span>
                </li>
                <li className="flex justify-between items-end border-b border-gray-800/50 pb-2">
                  <div>
                    <span className="block text-light font-medium">Small Piece</span>
                    <span className="text-xs text-muted">Under 3 inches, simple design</span>
                  </div>
                  <span className="text-secondary font-display text-xl">CA$120–250</span>
                </li>
                <li className="flex justify-between items-end border-b border-gray-800/50 pb-2">
                  <div>
                    <span className="block text-light font-medium">Medium Piece</span>
                    <span className="text-xs text-muted">Palm to hand size</span>
                  </div>
                  <span className="text-secondary font-display text-xl">CA$250–600</span>
                </li>
                <li className="flex justify-between items-end border-b border-gray-800/50 pb-2">
                  <div>
                    <span className="block text-light font-medium">Large Projects</span>
                    <span className="text-xs text-muted">Half sleeves, backs, chests</span>
                  </div>
                  <span className="text-secondary font-display text-xl">Custom Quote</span>
                </li>
                <li className="flex justify-between items-end pb-2">
                  <div>
                    <span className="block text-light font-medium">Full Sleeves</span>
                    <span className="text-xs text-muted">Multi-session projects</span>
                  </div>
                  <span className="text-secondary font-display text-lg">Consultation Req.</span>
                </li>
              </ul>
            </div>

            <div className="space-y-8">
              <div className="bg-primary p-6 border border-gray-800">
                <div className="flex gap-3 mb-3">
                  <SafeIcon icon={FiInfo} className="text-secondary text-xl shrink-0" />
                  <h4 className="font-medium text-light">Why Does Pricing Vary?</h4>
                </div>
                <p className="text-sm text-muted leading-relaxed">
                  Final pricing is determined by size, placement on the body (some areas are harder to tattoo), complexity of the design, and color versus black & grey. Quotes are finalized during your consultation.
                </p>
              </div>

              <div>
                <h4 className="font-display text-xl text-light mb-3">Deposits</h4>
                <p className="text-muted text-sm mb-4">
                  A non-refundable deposit of CA$100 is required to secure all appointments. This comes off the final price of your tattoo.
                </p>
              </div>

              <div>
                <h4 className="font-display text-xl text-light mb-3">Touch-Ups</h4>
                <p className="text-muted text-sm">
                  We guarantee our work. One free touch-up is included within 6 months of your initial appointment (excluding hands and feet).
                </p>
              </div>
            </div>
          </div>

          <div className="mt-12 text-center pt-8 border-t border-gray-800">
            <p className="text-light mb-6">Ready to get a precise quote for your idea?</p>
            <Link to="/booking" className="inline-block bg-secondary text-primary px-8 py-4 font-medium hover:bg-light transition-colors uppercase tracking-wider text-sm">
              Book a Free Consultation
            </Link>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Pricing;